package feature.employee.viewModel

import feature.app.AppViewModel
import feature.auth.model.FriendlyProfile
import feature.auth.model.FriendlyUser
import feature.employee.handler.EmployeeHandler
import feature.employee.model.Employee
import feature.employee.model.EmployeeAttendance
import feature.employee.repository.EmployeeRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class EmployeeViewModel : AppViewModel() {
    val repository: EmployeeRepository = EmployeeHandler.shared().repository
    val allEmployee: StateFlow<ArrayList<Employee>>
        get() = repository.allEmployee

    val employee: StateFlow<Employee>
        get() = repository.employee

    val profile: StateFlow<FriendlyProfile>
        get() = repository.profile

    //Attendance
    val allEmployeeAttendance: StateFlow<ArrayList<EmployeeAttendance>>
        get() = repository.allEmployeeAttendance

    val employeeAttendanceData: StateFlow<EmployeeAttendance>
        get() = repository.employeeAttendanceData
    val searchQuery: StateFlow<String>
        get() = repository.searchQuery

    override fun changeSearchQuery(value: String) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            repository.searchQueryState.emit(value)
        }
        performSearch(value)
    }

    override fun performSearch(value: String) {
        val searchQueryText = value.lowercase()
        CoroutineScope(Job() + Dispatchers.Default).launch {
            val filteredResult = repository.allEmployee.value.filter { item ->
                item.Name?.lowercase()
                    ?.contains(searchQueryText) == true || item.MobileNumber?.lowercase()
                    ?.contains(searchQueryText) == true || item.EmailID?.lowercase()?.contains(
                    searchQueryText
                ) == true
            } as ArrayList<Employee>
            repository.allEmployeeLiveData.emit(filteredResult)
        }
    }

//    fun loadAttendanceFor(employee: Employee){
//        employeeRepository.allEmployeeAttendanceLiveData.postValue(arrayListOf())
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            employeeRepository.allEmployeeAttendanceLiveData.postValue(DatabaseHandler.shared().database.employeeAttendanceDao().getAllItemsFor(employee.Id) as ArrayList<EmployeeAttendance>?)
//        }
//    }

    fun fetchAllEmployee() {
        val user = FriendlyUser()
//        var request = Json()
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, BusinessHandler.shared().repository.business.value?.Id)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        SocketService.shared().send(SocketEvent.RETRIVE_EMPLOYEE, request)
    }

    fun createNew(employeeProfile: FriendlyProfile) {
        val user = FriendlyUser()
//        var request = JSONObject()
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, BusinessHandler.shared().repository.business.value?.Id)
//        request.put(KeyConstant.name, employeeProfile.Name)
//        request.put(KeyConstant.mobileNumber, employeeProfile.MobileNumber)
//        request.put(KeyConstant.employeeUserID, employeeProfile.Id)
//        request.put(KeyConstant.emailId, employeeProfile.EmailID)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        SocketService.shared().send(SocketEvent.CREATE_EMPLOYEE, request)
    }

    fun insert(employee: Employee) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.employeeDao()
//                .insert(employee)
//        }
    }

    fun findUser(mobile: String) {
        val user = FriendlyUser()
//        var request = JSONObject()
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, BusinessHandler.shared().repository.business.value?.Id)
//        request.put(KeyConstant.mobileNumber, mobile)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        SocketService.shared().send(SocketEvent.FIND_USER, request)
    }

    fun createNewAttendance(
        employee: Employee,
        isPresent: Boolean,
        date: String,
        hours: Float,
        comment: String
    ) {
        val user = FriendlyUser()
//        val request = JSONObject()
//        val business = BusinessHandler.shared().repository.business.value
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, business?.Id)
//        request.put(KeyConstant.employeeUserID, employee.EmployeeUserID)
//        request.put(KeyConstant.employeeID, employee.Id)
//        request.put(KeyConstant.attendanceDate, date)
//        request.put(KeyConstant.isPresent, isPresent)
//        request.put(KeyConstant.hours, hours)
//        request.put(KeyConstant.comment, comment)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        SocketService.shared().send(SocketEvent.ADD_EMPLOYEE_ATTENDACE, request)
    }

    fun insertAttendance(attendance: EmployeeAttendance) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.employeeAttendanceDao()
//                .insert(attendance)
//        }
    }

    fun isPresent(dateString: String, employee: Employee): Boolean? {
        allEmployeeAttendance.value.forEach {
            if (it.AttendanceDate?.contains(dateString) == true) {
                return it.IsPresent
            }
        }
        return null
    }
}